import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material'
import { AdminThemeDto } from '@api/types/themes'

interface ThemeDeleteDialogProps {
  open: boolean
  theme: AdminThemeDto | null
  deleting: boolean
  onClose: () => void
  onConfirm: () => void
}

export function ThemeDeleteDialog({ open, theme, deleting, onClose, onConfirm }: ThemeDeleteDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Theme</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete <strong>{theme?.name}</strong>?
          {theme && theme.userCount > 0 && (
            <> This theme is currently assigned to {theme.userCount} user(s).</>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={deleting}>Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained" disabled={deleting}>
          {deleting ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
